import { useEffect, useState } from "react";

const useTelegramLoader = () => {
  const [isTelegramLoaded, setIsTelegramLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (global?.Telegram) {
        setIsTelegramLoaded(true);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return isTelegramLoaded;
};

export default useTelegramLoader;
